import React from 'react'
import './Common_Back_Btn.css'
import { useNavigate } from 'react-router-dom'


const Common_Back_Header = ({ delivered, backNavigation, showReOrder }) => {

  const navigate = useNavigate()
  return (
    <section className='Common_Back_Header'>
      <p className='back_text' onClick={() => {
        if (typeof backNavigation === "number") {
          navigate(backNavigation);
        } else {
          navigate(backNavigation || "/");
        }
      }}>Back</p>

      {/* {showReOrder && (
        <div className='btn_holder' onClick={() => { navigate("/cart") }}>
          <Green_Btn btn_name="Reorder"  onClick={reOrder}/>
        </div>
      )} */}


    </section>
  )
}

export default Common_Back_Header